const values = [
  {
    index: '01',
    title: 'Scalable Architecture',
    description:
      'Designing systems that grow with your needs, built on modular and maintainable foundations from day one.',
    bgClass: 'bg-accent-50',
  },
  {
    index: '02',
    title: 'Performance First',
    description:
      'Optimizing every layer of the stack to deliver fast, responsive, and efficient software experiences.',
    bgClass: 'bg-secondary-50',
  },
  {
    index: '03',
    title: 'Clean Code Standards',
    description:
      'Adhering to rigorous code review practices and industry-standard patterns that ensure long-term readability.',
    bgClass: 'bg-primary-50',
  },
  {
    index: '04',
    title: 'Continuous Innovation',
    description:
      'Actively exploring emerging technologies and evolving internal workflows to stay at the forefront of engineering.',
    bgClass: 'bg-accent-50',
  },
];

export default function ValuesSection() {
  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="px-6 md:px-12 max-w-7xl mx-auto">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between">
          <div>
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 leading-tight tracking-tight">
              Technical{' '}
              <span className="text-primary-500">values</span>
            </h3>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              The principles that guide every engineering decision
            </p>
          </div>
          <div className="mt-4 md:mt-0">
            <span className="inline-block px-4 py-1.5 rounded-full bg-foreground-900 text-background-50 text-xs uppercase tracking-[0.12em] font-medium">
              Our Standards
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((value) => (
            <div
              key={value.index}
              className={`rounded-2xl ${value.bgClass} p-6 md:p-7 flex flex-col`}
            >
              <div className="mb-6 w-12 h-12 rounded-full bg-background-50 flex items-center justify-center">
                <span className="text-lg font-bold text-foreground-800">
                  {value.index}
                </span>
              </div>
              <h4 className="text-base md:text-lg font-semibold text-foreground-900 mb-3">
                {value.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}